import React from 'react'
import { getPublicacionAvisoURL } from '../../../../constants/aviso/publicacion/get-url-publicacion-aviso'
import { DashboardDataLayers } from '../../../../constants/gtm-events/gtm-events-dashboard'
import { ButtonAviso } from './mixins'
import { useScreenSize } from '@navent-jobs/ui-kit/hooks/screen-size'

const Component = () => {
  const { isMobile } = useScreenSize()

  const onClick = async () => {
    await DashboardDataLayers.clickMenuHeader('Crear nuevo aviso')
    window.location.href = getPublicacionAvisoURL({})
  }

  const label = isMobile ? 'Crear aviso' : 'Crear nuevo aviso'

  return (
    <ButtonAviso
      onClick={onClick}
      buttonoptions={{ size: 'small', variant: 'primary', type: isMobile ? 'link' : 'fill' }}
    >
      {label}
    </ButtonAviso>
  )
}

export default React.memo(Component)
